<form [formGroup]="groupForm" class="category-container category-content">
  <span class="third-title">{{ group.category }}</span>
    <div *ngFor="let commitment of group.commitments;" class="commitment-container">
        <span class="commitment-title">
          <mat-icon *ngIf="commitment.template.categoryLevel > 1" class="sublevel-icon">
            subdirectory_arrow_right
          </mat-icon>
          {{ commitment.template.title }}
        </span>
        <div
          class="tv-rect-input-small-no-label width-180px"
          [ngClass]="{
            'mat-form-field-invalid': (groupErrors[groupPrefix + commitment.id] ?? null) != null,
            'disabled-form-field': !commitment.template.editable || isPastYearContract
          }">
          <mat-form-field>
            <input
              matInput
              realThousandsSeparator
              [formControlName]="groupPrefix + commitment.id"
              [value]="commitment.value"
              [readonly]="!commitment.template.editable || isPastYearContract"
              (focusout)="onInputChange(commitment)"
            />
          </mat-form-field>
        </div>
    </div>
  <div class="total-container">
    <mat-divider></mat-divider>
    <div class="commitment-container">
      <span class="commitment-title">Total</span>
      <div class="tv-rect-input-small-no-label width-180px disabled-form-field">
        <mat-form-field>
          <input
            matInput
            realThousandsSeparator
            [value]="groupValue"
            [readonly]="true"
          />
        </mat-form-field>
      </div>
    </div>
  </div>
</form>
